import React, { Component } from 'react';
import { PageContainer, TextBlock, Header, PageTitle, BottomButtons, Button, TopicList, Topic } from '../components/styledComponents'

import { topics } from '../data/topics'

export default class TopicSelect extends Component {

  state = {
    topics
  }

	render() {
    const topicList = this.state.topics.map((topic, index) => <Topic
      img={topic.img}
      key={index}
      selected={topic.selected}
      onClick={() => {
        this.props.chooseTopic(topic.title)
      }}> 
      <div>
        <span>{topic.title}</span>
      </div>      
    </Topic>)

		return (
			<PageContainer>
        <TextBlock>Select a topic to get started</TextBlock>
        <TopicList>
          { topicList }
        </TopicList>
        <BottomButtons>
        </BottomButtons>
			</PageContainer>
		)
	}

}
